var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("delegation-rate-menu"),
      _c("h2", [
        _vm._v(
          " " +
            _vm._s(
              _vm.$t("settings.delegationRate.standardDelegationRate.title")
            ) +
            " "
        )
      ]),
      _c(
        "v-row",
        { staticClass: "mb-3" },
        [
          _c(
            "v-col",
            { attrs: { cols: "3" } },
            [
              _c("v-text-field", {
                attrs: {
                  label: _vm.$t("global.search"),
                  "append-icon": "search",
                  "hide-details": "",
                  "single-line": ""
                },
                model: {
                  value: _vm.search,
                  callback: function($$v) {
                    _vm.search = $$v
                  },
                  expression: "search"
                }
              })
            ],
            1
          ),
          _c("v-spacer"),
          _c(
            "div",
            [
              _c(
                "v-btn",
                {
                  attrs: { block: "", color: "primary" },
                  on: { click: _vm.reset }
                },
                [
                  _vm._v(
                    _vm._s(
                      _vm.$t(
                        "settings.delegationRate.standardDelegationRate.revertStatutoryRates"
                      )
                    )
                  )
                ]
              )
            ],
            1
          ),
          _c(
            "div",
            [
              _c(
                "DelegationRateFormDialog",
                { on: { saved: _vm.loadList } },
                [
                  _c("v-btn", { attrs: { block: "", color: "accent" } }, [
                    _vm._v(
                      _vm._s(
                        _vm.$t(
                          "settings.delegationRate.standardDelegationRate.addNewRate"
                        )
                      )
                    )
                  ])
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c("v-data-table", {
        attrs: {
          headers: _vm.headers,
          items: _vm.delegationRate,
          search: _vm.search,
          "custom-filter": _vm.filterOverAllProperty,
          "sort-by": "country_symbol"
        },
        scopedSlots: _vm._u([
          {
            key: "item",
            fn: function(props) {
              return [
                _c("tr", [
                  _c("td", { staticClass: "text-left" }, [
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm.getCountryTranslatedName(
                            props.item.country_symbol
                          )
                        ) +
                        " "
                    )
                  ]),
                  _c("td", { staticClass: "text-left" }, [
                    _vm._v(_vm._s(props.item.region))
                  ]),
                  _c("td", { staticClass: "text-left" }, [
                    _vm._v(
                      _vm._s(props.item.amount) +
                        " " +
                        _vm._s(props.item.currency)
                    )
                  ]),
                  _c("td", { staticClass: "text-left" }, [
                    _vm._v(
                      _vm._s(props.item.hotel_limit) +
                        " " +
                        _vm._s(props.item.currency)
                    )
                  ]),
                  _c(
                    "td",
                    { staticClass: "text-center text-no-wrap" },
                    [
                      _c("DelegationRateFormDialog", {
                        attrs: { id: props.item.id },
                        on: { saved: _vm.loadList }
                      }),
                      _c(
                        "v-tooltip",
                        {
                          attrs: { bottom: "" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "activator",
                                fn: function(ref) {
                                  var on = ref.on
                                  return [
                                    _c(
                                      "v-btn",
                                      _vm._g(
                                        {
                                          attrs: { icon: "" },
                                          nativeOn: {
                                            click: function($event) {
                                              return _vm.remove(props.item)
                                            }
                                          }
                                        },
                                        on
                                      ),
                                      [_c("v-icon", [_vm._v("delete")])],
                                      1
                                    )
                                  ]
                                }
                              }
                            ],
                            null,
                            true
                          )
                        },
                        [_vm._v(" " + _vm._s(_vm.$t("global.delete")) + " ")]
                      )
                    ],
                    1
                  )
                ])
              ]
            }
          }
        ])
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }